import React, {Component} from 'react'
import ProfileBase from './helpers/ProfileBase'
import EducationBox from './helpers/EducationBox'
import TestAnswersBox from './helpers/TestAnswersBox'
import AdditionalTalentNotesBox from './helpers/AdditionalTalentNotesBox'

class EditorProfile extends Component {
  render() {
    return (
      <ProfileBase profileUrlPart="editor" render={( profileData ) => (
        <div>
          {profileData.ProfileType === 'Editor' &&
            <div>
              <div className="row">
                <div className="col-md-6 widget">
                  <div className="title">Experience</div>
                  <div className="row">
                    <div className="col">
                      <div className="row">
                        <div className="col-4">Productions:</div>
                        <div className="col-8">{profileData.ExperienceProductions}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">Skills:</div>
                        <div className="col-8">{profileData.ExperienceGroup2}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">Additional experience:</div>
                        <div className="col-8">{profileData.Experience}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">Studios:</div>
                        <div className="col-8">{profileData.LocalizationCompanies}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">Clients:</div>
                        <div className="col-8">{profileData.ProductionContentOwners}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <EducationBox schools={profileData.Schools} />
              </div>
              <div className="row">
                <TestAnswersBox />
                <AdditionalTalentNotesBox additionalNotes={profileData.AdditionalNotes} />
              </div>
            </div>
          }
        </div>
      )}/>
    )
  }
}

export default EditorProfile
